import React, { Component } from 'react';
import PropTypes from 'prop-types';

import GeofenceEditorActionSheet from './GeofenceEditorActionSheet.jsx';
import { GeofenceEditorPanelWrapper } from './GeofenceEditorPanelWrapper.tsx';
import DeviceMapModalV2 from './DeviceMapModalV2';

class GeofenceEditorOverlay extends Component {
  state = {
    showGeofenceEditor: false,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.geofence !== this.props.geofence) {
      // Reset internal state if the geofence has changed
      this.setState({ showGeofenceEditor: false });
    }
  }

  render() {
    const { open, geofence, onClose, onSave, onDelete } = this.props;

    return (
      <React.Fragment>
        <GeofenceEditorActionSheet
          open={open}
          geofence={geofence}
          onCancel={onClose}
          onNext={() => this.setState({ showGeofenceEditor: true })}
          />

        <DeviceMapModalV2
          open={open && this.state.showGeofenceEditor}
          onClose={() => this.setState({ showGeofenceEditor: false })}>
          <GeofenceEditorPanelWrapper 
            geofence={geofence}
            onSave={onSave}
            onDelete={onDelete}
          />
        </DeviceMapModalV2>
      </React.Fragment>
    );
  }
}

GeofenceEditorOverlay.propTypes = {
  open: PropTypes.bool,
  geofence: PropTypes.object,
  onSave: PropTypes.func,
  onDelete: PropTypes.func,
  onClose: PropTypes.func,
};

export default GeofenceEditorOverlay;
